import { ExpiringLotsFilter, ExpiringLotsSummary, ExpiringScope, LotExpiryStatus } from 'app/report/domain/expiring-lots';
import { DateFormat, format } from 'shared/utils/date';

interface StatusDisplay {
  label: string;
  badgeClass: string;
}

export const STATUS_DISPLAY: Record<LotExpiryStatus, StatusDisplay> = {
  [LotExpiryStatus.Expired]: { label: 'Vencido', badgeClass: 'badge-danger' },
  [LotExpiryStatus.ExpiringSoon]: { label: 'Por vencer', badgeClass: 'badge-warning' },
  [LotExpiryStatus.Upcoming]: { label: 'Próximo', badgeClass: 'badge-info' },
  [LotExpiryStatus.Valid]: { label: 'Vigente', badgeClass: 'badge-success' },
};

export const SCOPE_OPTIONS: { scope: ExpiringScope; label: string }[] = [
  { scope: ExpiringScope.Attention, label: 'Requiere atención' },
  { scope: ExpiringScope.Expired, label: 'Vencidos' },
  { scope: ExpiringScope.Next30Days, label: '30 días' },
  { scope: ExpiringScope.Next90Days, label: '90 días' },
  { scope: ExpiringScope.All, label: 'Todos' },
  { scope: ExpiringScope.Custom, label: 'Personalizado' },
];

const DAYS_IN_PLURAL = 2;

const days = (count: number): string => `${count} ${count < DAYS_IN_PLURAL ? 'día' : 'días'}`;

export const daysLeftLabel = (daysLeft: number): string => {
  if (daysLeft === -1) return 'Venció ayer';
  if (daysLeft < 0) return `Venció hace ${days(Math.abs(daysLeft))}`;
  if (daysLeft === 0) return 'Vence hoy';
  if (daysLeft === 1) return 'Vence mañana';
  return `Vence en ${days(daysLeft)}`;
};

export const lotsCount = (count: number): string => `${count} ${count === 1 ? 'lote' : 'lotes'}`;

const shortDate = (date: Date): string => format(date, DateFormat.Default);

export const scopeDescription = ({ scope, dateFrom, dateTo }: ExpiringLotsFilter, summary: ExpiringLotsSummary): string => {
  const descriptions: Record<ExpiringScope, string> = {
    [ExpiringScope.Attention]: `Vencidos y los que vencen en los próximos ${summary.upcomingDays} días`,
    [ExpiringScope.Expired]: 'Lotes vencidos con stock',
    [ExpiringScope.Next30Days]: `Vencen en los próximos ${summary.expiringSoonDays} días`,
    [ExpiringScope.Next90Days]: `Vencen en los próximos ${summary.upcomingDays} días`,
    [ExpiringScope.All]: 'Todos los lotes con stock',
    [ExpiringScope.Custom]: dateFrom && dateTo ? `Vencen del ${shortDate(dateFrom)} al ${shortDate(dateTo)}` : 'Rango personalizado',
  };
  return descriptions[scope];
};
